import React, { useState } from "react";
import GroupHeadDeal from "../../dashboard-util/dashboard-grouphead/group-head-deal";
import CMEGroupHeadAllDealsModal from "./cme-group-head-all-deals-modal";
import { GetCMEGroupHeadDealLogExcelExport } from "../../../../services/api/dashboard-api";
import PropTypes from "prop-types";

const CMEGroupHeadDeal = ({ items }) => {
    const tableHeaders = ["Name", "Number of Deals", "Number of Analysts/Associates", "Number of Sub Sectors", "Number of Deal Types"];
    const [selectedMember, setSelectedMember] = useState(null);
    const [show, setShow] = useState(false);
  
    const showModal = (member) => {
    setSelectedMember(member);
      setShow(true);
    };
  
    const onHide = () => {
    setSelectedMember(null);
      setShow(false);
    };

    const renderExtraColumns = (item) => (
        <>
            <td className="col-md-1 col-sm-1 mt-2">{item.NumberOfSubSectors}</td>
            <td className="col-md-1 col-sm-1 mt-2">{item.NumberOfDealTypes}</td>
        </>
    );

    return (
      <>
        <GroupHeadDeal
          items={items}
          title="Senior Management Deal Tracker"
          departmentTitle="GIB/CME"
          tableHeaders={tableHeaders}
          renderExtraColumns={renderExtraColumns}
          showModal={showModal}
          exportData={GetCMEGroupHeadDealLogExcelExport}
          disableExport={false}
        />
        {show && selectedMember && (
          <CMEGroupHeadAllDealsModal
            item={selectedMember}
            show={show}
            onHide={onHide}
          />
        )}
      </>
    );
};

CMEGroupHeadDeal.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            GroupHeadName: PropTypes.string.isRequired,
            NumberOfDeals: PropTypes.number.isRequired,
            NumberOfAnalystsAssociates: PropTypes.number.isRequired,
        }).isRequired
    ).isRequired,
};

export default React.memo(CMEGroupHeadDeal);
